import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { getStatistics } from "@/pages/asset-details/repositories/AssetDetailsRepositorie";
import { get } from "react-hook-form";

type Props = {
	setIsStatisticsLoading: (isLoading: boolean) => void;
	setStatisticsError: (err: string) => void;
};

export const useSearchStatistics = ({
	setIsStatisticsLoading,
	setStatisticsError,
}: Props) => {
	const {
		state: { assetSearchId },
		actions: { setStatisticsRows, setStatisticsColumns },
	} = useAssetDetailsContext();

	return async () => {
		setIsStatisticsLoading(true);
		const res = await getStatistics(assetSearchId);
		if (res.ok) {
			const rows = get(res, "data.tables[0].rows", []);
			const columns = get(res, "data.tables[0].columns", []);

			if (rows && rows.length > 0) {
				const statisticsArr = [
					{
						Name: "Open Orders",
						Value: rows[0].PMWorkOrders + rows[0].RMWorkOrders,
					},
					{
						Name: "Close Orders",
						Value: rows[0].PMWorkOrdersClosed + rows[0].RMWorkOrdersClosed,
					},
					{
						Name: "Children Open Orders",
						Value:
							rows[0].PMWorkOrdersDescendants + rows[0].RMWorkOrdersDescendants,
					},
					{
						Name: "Children Close Orders",
						Value:
							rows[0].PMWorkOrdersDescendantsClosed +
							rows[0].RMWorkOrdersDescendantsClosed,
					},
					{
						Name: "Drawings Linked",
						Value: rows[0].DrawingsLinked,
					},
					{
						Name: "Parts Linked",
						Value: rows[0].PartsLinked,
					},
					{
						Name: "LOTOs Linked",
						Value: rows[0].LOTOLinked,
					},
					{
						Name: "Attachments Linked",
						Value: rows[0].AttachmentsLinked,
					},
				];

				setStatisticsRows(statisticsArr);
				setStatisticsColumns(columns);
			} else {
				setStatisticsRows([]);
				setStatisticsColumns([]);
			}
		} else {
			setStatisticsError(res.message);
		}
		setIsStatisticsLoading(false);
	};
};
